module.exports = __webpack_public_path__ + "static/img/drsy.1b345cc5.png";